// extracted by mini-css-extract-plugin
export default {"list":"HabitacionesLista_list__XM1U0"};